module.exports = __webpack_public_path__ + "img/txt.c15c2101.svg";